import { Box, Stack } from '@mui/material';
import { AnalyticsEventName, trackAmplitudeEvent } from '@schooly/analytics';
import { PAGE } from '@schooly/constants';
import React, { FC, useEffect } from 'react';
import { Outlet } from 'react-router-dom';

import Header from '../../../components/ui/Header';
import MainLayout from '../../../components/uikit-components/MainLayout/MainLayout';
import { useSchool } from '../../../hooks/useSchool';
import AccessDeniedPage from '../../AccessDenied';
import { SchoolAttendanceCodes } from './SchoolAttendanceCodes/SchoolAttendanceCodes';
import { SchoolAttendanceFrequencies } from './SchoolAttendanceFrequencies/SchoolAttendanceFrequencies';

export const SchoolAttendance: FC = () => {
  const { isSchoolAdmin } = useSchool();

  useEffect(() => {
    trackAmplitudeEvent({
      name: AnalyticsEventName.AttendanceSettingsView,
    });
  }, []);

  if (!isSchoolAdmin) {
    return <AccessDeniedPage />;
  }

  return (
    <MainLayout>
      <Box sx={{ whiteSpace: 'nowrap' }} data-test-id={PAGE.HEADER}>
        <Header pageTitleTextId="section-AttendanceSettings" />
      </Box>

      <Stack gap={2}>
        <SchoolAttendanceFrequencies />
        <SchoolAttendanceCodes />
      </Stack>

      <Outlet />
    </MainLayout>
  );
};
